import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import InsuranceFlowChecksComponent from "./InsuranceFlowChecksComponent";

const InsuranceFlowChecksContainer = () => {
  const history = useHistory();

  const handleOpenInsuranceFlowRcaChecks = useCallback(() => {
    history.push(`/settings/rca-checks`);
  }, [history]);

  const handleOpenInsuranceFlowCascoChecks = useCallback(() => {
    history.push(`/settings/casco-checks`);
  }, [history]);

  return (
    <InsuranceFlowChecksComponent
      onOpenInsuranceFlowRcaChecks={handleOpenInsuranceFlowRcaChecks}
      onOpenInsuranceFlowCascoChecks={handleOpenInsuranceFlowCascoChecks}
    />
  );
};

InsuranceFlowChecksContainer.propTypes = {};

export default InsuranceFlowChecksContainer;
